import { render, staticRenderFns } from "./SupplyChainTab.vue?vue&type=template&id=fc54aa14&scoped=true&"
import script from "./SupplyChainTab.vue?vue&type=script&lang=js&"
export * from "./SupplyChainTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc54aa14",
  null
  
)

export default component.exports